/**
 * Arabic interface text (D119), keyed by the English original. Modern Standard
 * Arabic with game wording; numbers stay Western digits (as on most Arabic
 * game UIs). Anything missing here simply shows in English.
 */
export const AR: Readonly<Record<string, string>> = {
  // ---- menu: home
  'Build. Survive. Command.': 'ابنِ. اصمد. قُد.',
  'Level {n}': 'المستوى {n}',
  '{n} pts': '{n} نقطة',
  Continue: 'متابعة',
  Campaign: 'الحملة',
  'Survival & Sandbox': 'البقاء والوضع الحر',
  Multiplayer: 'متعدد اللاعبين',
  Raid: 'غارة',
  'Season Pass': 'تذكرة الموسم',
  Rankings: 'التصنيف',
  Settings: 'الإعدادات',
  'How to play': 'طريقة اللعب',
  '← Back': '→ رجوع',
  // ranks
  Survivor: 'ناجٍ',
  Scavenger: 'منقّب',
  Captain: 'قائد',
  Commander: 'آمر',
  Warlord: 'أمير حرب',
  // ---- solo modes
  'Endless Survival': 'بقاء بلا نهاية',
  Sandbox: 'الوضع الحر',
  Skirmish: 'مناوشة',
  'Hordes forever, faster and bigger. How long can you last?': 'جحافل لا تنتهي، أسرع وأكبر. إلى متى ستصمد؟',
  'Build freely, try units and defences.': 'ابنِ بحرية وجرّب الوحدات والتحصينات.',
  'A rival colony played by the computer (normal).': 'مستعمرة منافسة يلعبها الكمبيوتر (متوسط).',
  'Against the computer': 'ضد الكمبيوتر',
  'A rival colony that builds, trains an army, defends and attacks you. Infected roam the middle.': 'مستعمرة منافسة تبني وتدرّب جيشًا وتدافع وتهاجمك. والمصابون يجوبون منتصف الخريطة.',
  Easy: 'سهل',
  Normal: 'متوسط',
  Hard: 'صعب',
  'Duel — no infected': 'مبارزة — بلا مصابين',
  // ---- campaign
  'each level is harder than the last.': 'كل مستوى أصعب من الذي قبله.',
  Tutorial: 'التدريب',
  'Training Grounds': 'ساحة التدريب',
  'New here? Learn to build, grow, train and defend, step by step.': 'جديد هنا؟ تعلّم البناء والنمو والتدريب والدفاع خطوة بخطوة.',
  'Not played': 'لم تُلعب بعد',
  'Clear the previous level': 'اجتز المستوى السابق',
  'Online rankings appear once the server is deployed.': 'يظهر التصنيف الأونلاين بعد تشغيل السيرفر.',
  'Loading rankings…': 'جارٍ تحميل التصنيف…',
  'None of your friends has a score here yet.': 'لا أحد من أصدقائك سجّل نتيجة هنا بعد.',
  'No scores yet — be the first.': 'لا توجد نتائج بعد — كن الأول.',
  "Scores are reported by each player's device.": 'النتائج يرسلها جهاز كل لاعب.',
  'Goal: survive {w} hordes, then hold {s} s': 'الهدف: اصمد أمام {w} جحافل، ثم اثبت {s} ثانية',
  'Your best:': 'أفضل نتيجة لك:',
  '★ win · ★ lose 3 buildings or fewer · ★ Command Center above 75 %': '★ الفوز · ★ خسارة 3 مبانٍ أو أقل · ★ مركز القيادة فوق 75٪',
  'Start level {n}': 'ابدأ المستوى {n}',
  Everyone: 'الجميع',
  Friends: 'الأصدقاء',
  'First Light': 'أول ضوء',
  'A quiet valley. Build farms and a sawmill, then hold off two small hordes.': 'وادٍ هادئ. ابنِ مزارع ومنشرة، ثم صُدّ جحفلين صغيرين.',
  'Fence Line': 'خط السياج',
  'Walls buy time. Three hordes, all from the same side.': 'الأسوار تكسب الوقت. ثلاثة جحافل، كلها من الجهة نفسها.',
  'Scrap Run': 'سباق الخردة',
  'Scrap is short. Expand to the yards before the third night.': 'الخردة قليلة. توسّع نحو الساحات قبل الليلة الثالثة.',
  'Fast Ones': 'السريعون',
  'Runners join the hordes. Towers before walls fall.': 'العدّاؤون ينضمون إلى الجحافل. أبراج قبل أن تسقط الأسوار.',
  Powerless: 'بلا كهرباء',
  'Gun Towers need Generators. Four hordes, growing fast.': 'أبراج الرشاشات تحتاج مولدات. أربعة جحافل تكبر بسرعة.',
  'Long Night': 'الليلة الطويلة',
  'Five hordes with little rest between them.': 'خمسة جحافل وراحة قليلة بينها.',
  Hungry: 'جوع',
  'Food is scarce and the infected are many. Feed the colony or lose it.': 'الطعام شحيح والمصابون كثيرون. أطعم المستعمرة أو اخسرها.',
  Siege: 'حصار',
  'Six hordes. The last ones come with dozens of Runners.': 'ستة جحافل. الأخيرة تأتي بعشرات العدّائين.',
  'Dead City': 'المدينة الميتة',
  'A ruined city crawling with the infected. Hold for seven hordes.': 'مدينة مدمّرة تعجّ بالمصابين. اصمد أمام سبعة جحافل.',
  'The Swarm': 'السرب',
  'Everything left out there is coming. Eight hordes. Then silence.': 'كل ما تبقى في الخارج قادم. ثمانية جحافل. ثم الصمت.',
  'Learn the basics step by step: build, grow, train soldiers and hold off one small horde.': 'تعلّم الأساسيات خطوة بخطوة: ابنِ، وكبّر المستعمرة، ودرّب الجنود، واصمد أمام جحفل صغير.',
  // ---- season pass
  'Season 1 — Ashfall': 'الموسم 1 — الرماد',
  Tier: 'المرحلة',
  '{a} / {b} XP to the next tier': '{a} / {b} نقطة خبرة للمرحلة التالية',
  complete: 'مكتمل',
  'Earn XP in every mode. Units and buildings on the Premium track also unlock for everyone on the Free track a few tiers later.': 'اكسب نقاط الخبرة في كل الأوضاع. الوحدات والمباني في المسار المميز تُفتح للجميع في المسار المجاني بعد بضع مراحل.',
  'Premium active': 'المميز مفعّل',
  'Get Premium': 'احصل على المميز',
  Free: 'مجاني',
  Premium: 'مميز',
  'Purchases are not connected yet — the Premium track opens once payments are set up.': 'الشراء غير متاح بعد — يُفتح المسار المميز عند تفعيل الدفع.',
  'Rust colony colours': 'ألوان الصدأ',
  'Night-ops colours': 'ألوان العمليات الليلية',
  'Gilded Command Center': 'مركز قيادة مُذهّب',
  'Ember Flamers': 'قاذفو اللهب الجمريون',
  'Ashfall colony set': 'طقم مستعمرة الرماد',
  Veteran: 'محارب قديم',
  'Ashfall Legend': 'أسطورة الرماد',
  // ---- raid
  'Online raids need the room server (not deployed yet). The practice bases below work offline.': 'الغارات الأونلاين تحتاج السيرفر (غير مشغّل بعد). قواعد التدريب بالأسفل تعمل بدون إنترنت.',
  'Looking for opponents…': 'جارٍ البحث عن خصوم…',
  'No other bases to raid yet — save yours from the Colony panel so others can find it.': 'لا توجد قواعد أخرى للإغارة بعد — احفظ قاعدتك من لوحة المستعمرة ليجدها الآخرون.',
  'Your army: 8 Rangers, 4 Heavies, 1 Engineer. Destroy the Command Center before the timer for stars, loot and ranking points.': 'جيشك: 8 رماة، 4 ثقيلي التسليح، مهندس واحد. دمّر مركز القيادة قبل انتهاء الوقت لتحصل على نجوم وغنائم ونقاط تصنيف.',
  Opponents: 'الخصوم',
  Practice: 'تدريب',
  '{b} buildings · {d} defenders': '{b} مبنى · {d} مدافع',
  'Your own base': 'قاعدتك أنت',
  'Test your defences': 'اختبر دفاعاتك',
  // ---- online
  'Create a room': 'أنشئ غرفة',
  'Room code': 'رمز الغرفة',
  Join: 'انضم',
  "<b>Last Colony</b> (2–4): the infected hit everyone. Break your friends' colonies while the hordes wear them down — build a <i>Horde Beacon</i> to send the next horde at a rival.":
    '<b>المستعمرة الأخيرة</b> (2–4): المصابون يهاجمون الجميع. حطّم مستعمرات أصدقائك بينما تنهكهم الجحافل — ابنِ <i>منارة الجحافل</i> لترسل الجحفل التالي إلى منافس.',
  '<b>Duel</b> (1 v 1): you against a friend, no infected.': '<b>مبارزة</b> (1 ضد 1): أنت ضد صديقك، بلا مصابين.',
  '<b>Classic RTS</b> (2–4, FFA or 2 v 2): bases, armies, a few infected in the wild.': '<b>الكلاسيكي</b> (2–4، الكل ضد الكل أو 2 ضد 2): قواعد وجيوش وبعض المصابين في البرية.',
  'The host picks the mode in the lobby. Share the invite link.': 'المضيف يختار الوضع في الردهة. شارك رابط الدعوة.',
  'Online play needs the room server, which is not deployed yet.': 'اللعب الأونلاين يحتاج السيرفر، وهو غير مشغّل بعد.',
  'Room codes are 5 letters.': 'رمز الغرفة 5 حروف.',
  // ---- profile / rankings
  Profile: 'الملف الشخصي',
  Name: 'الاسم',
  'Name saved.': 'تم حفظ الاسم.',
  'Colony look': 'شكل المستعمرة',
  Standard: 'الافتراضي',
  'Earn skins in the Season Pass.': 'اكسب الأشكال من تذكرة الموسم.',
  'Saved.': 'تم الحفظ.',
  '{a} / {b} XP to the next level': '{a} / {b} نقطة خبرة للمستوى التالي',
  '{p} ranking points · {w} wins in the last {m} matches': '{p} نقطة تصنيف · {w} انتصار في آخر {m} مباراة',
  History: 'السجل',
  vs: 'ضد',
  Victory: 'نصر',
  Defeat: 'هزيمة',
  'No matches yet.': 'لا مباريات بعد.',
  'Rankings are online — they appear once the room server is deployed. Your own points are on your profile.': 'التصنيف أونلاين — يظهر بعد تشغيل السيرفر. نقاطك موجودة في ملفك الشخصي.',
  'Loading…': 'جارٍ التحميل…',
  'No ranked players yet.': 'لا يوجد لاعبون مصنّفون بعد.',
  'Your player code:': 'رمز اللاعب الخاص بك:',
  'appears after you go online once': 'يظهر بعد أول دخول أونلاين',
  "Friend's code": 'رمز صديقك',
  Add: 'أضف',
  'Friends need the online server.': 'الأصدقاء يحتاجون السيرفر الأونلاين.',
  'A player code is 16 letters and digits.': 'رمز اللاعب 16 حرفًا ورقمًا.',
  'Added {name}.': 'تمت إضافة {name}.',
  'your friend': 'صديقك',
  'No player with that code.': 'لا يوجد لاعب بهذا الرمز.',
  // ---- settings
  'Sound effects': 'المؤثرات الصوتية',
  Music: 'الموسيقى',
  'Music volume': 'مستوى الموسيقى',
  Volume: 'مستوى الصوت',
  'Vibration (phones)': 'الاهتزاز (للهواتف)',
  Graphics: 'الرسوميات',
  High: 'عالية',
  'Low (older phones)': 'منخفضة (للهواتف القديمة)',
  // ---- help
  '<b>Build</b> from the bar at the bottom: tap a building, tap the map, confirm. Workers come from your survivors.': '<b>البناء</b> من الشريط في الأسفل: اختر مبنى، المس الخريطة، ثم أكّد. العمّال يأتون من الناجين.',
  '<b>Economy</b>: Farms feed survivors, Sawmills and Scrap Yards gather; Warehouses store. Housing lets more survivors join.': '<b>الاقتصاد</b>: المزارع تطعم الناجين، والمناشر وساحات الخردة تجمع الموارد، والمخازن تحفظها. المساكن تسمح بانضمام ناجين أكثر.',
  '<b>Army</b>: train Rangers, Heavies and Engineers at the Barracks. Tap <i>Army</i> to select everyone, tap the ground to move, <i>Attack-move</i> to fight on the way.': '<b>الجيش</b>: درّب الرماة وثقيلي التسليح والمهندسين في الثكنة. المس <i>Army</i> لتحديد الجميع، والمس الأرض للتحرك، و<i>Attack-move</i> للقتال في الطريق.',
  '<b>Camera</b>: drag with one finger to pan, pinch to zoom. On a computer: drag, WASD / arrows, mouse wheel.': '<b>الكاميرا</b>: اسحب بإصبع واحد للتحريك، وقرّب بإصبعين. على الكمبيوتر: السحب أو WASD / الأسهم وعجلة الماوس.',
  '<b>Infected</b>: bites infect; an infected survivor dies and rises as a Walker. Walls, Gates and Gun Towers (needs a Generator) hold hordes.': '<b>المصابون</b>: العضّة تنقل العدوى؛ الناجي المصاب يموت ثم ينهض سائرًا. الأسوار والبوابات وأبراج الرشاشات (تحتاج مولدًا) تصدّ الجحافل.',
  '<b>Campaign</b>: hold out until the last horde of the level is spent. Stars for losing little; each level is harder.': '<b>الحملة</b>: اصمد حتى ينتهي آخر جحفل في المستوى. نجوم أكثر كلما خسرت أقل؛ وكل مستوى أصعب.',
  '<b>Win online</b>: destroy every rival Command Center. Lose yours and you are out.': '<b>الفوز أونلاين</b>: دمّر كل مراكز قيادة المنافسين. إن خسرت مركزك تخرج من المباراة.',
  // ---- modes
  'Classic RTS': 'الكلاسيكي',
  'Last Colony': 'المستعمرة الأخيرة',
  'Raid & Domination': 'الغارة والهيمنة',
  Duel: 'مبارزة',
  // ---- buildings / units
  'Command Center': 'مركز القيادة',
  'Survivor Housing': 'مساكن الناجين',
  Sawmill: 'منشرة',
  Farm: 'مزرعة',
  Warehouse: 'مخزن',
  'Basic Wall': 'سور',
  'Scrap Yard': 'ساحة الخردة',
  'Military Barracks': 'ثكنة عسكرية',
  Workshop: 'ورشة',
  Gate: 'بوابة',
  Watchtower: 'برج مراقبة',
  'Gun Tower': 'برج رشاش',
  Generator: 'مولّد',
  'Flame Tower': 'برج اللهب',
  'Horde Beacon': 'منارة الجحافل',
  Ranger: 'رامٍ',
  Heavy: 'ثقيل',
  Engineer: 'مهندس',
  Sniper: 'قنّاص',
  Flamer: 'قاذف لهب',
  Walker: 'سائر',
  Runner: 'عدّاء',
  // ---- weekly (D123)
  'Weekly Challenge': 'تحدي الأسبوع',
  '{d}d {h}h left': 'باقي {d} يوم و{h} ساعة',
  '{h}h left': 'باقي {h} ساعة',
  'Everyone plays the same map this week. Your first finished run is your score; later runs are practice.': 'الكل يلعب نفس الخريطة هذا الأسبوع. أول محاولة تكملها هي نتيجتك؛ وما بعدها تدريب.',
  'Your score:': 'نتيجتك:',
  '{n} runs': '{n} محاولات',
  'Not played yet this week.': 'لم تلعب هذا الأسبوع بعد.',
  'Play this week’s challenge': 'العب تحدي الأسبوع',
  'Weekly Challenge cleared': 'اجتزت تحدي الأسبوع',
  'Weekly Challenge failed': 'فشلت في تحدي الأسبوع',
  'This is your score for the week.': 'هذه نتيجتك لهذا الأسبوع.',
  'Practice run — your first attempt ({n}) is the one that counts.': 'محاولة تدريب — أول محاولة ({n}) هي المحسوبة.',
  score: 'النتيجة',
  'Scrap Drought': 'جفاف الخردة',
  'Barely any scrap to start with. Towers will cost you.': 'خردة قليلة جدًا في البداية. الأبراج ستكلّفك.',
  'Fast Week': 'أسبوع السرعة',
  'Runners from the very first horde.': 'عدّاؤون من أول جحفل.',
  'Crowded Valley': 'الوادي المزدحم',
  'The infected already fill the middle of the map.': 'المصابون يملؤون منتصف الخريطة من البداية.',
  'Lean Times': 'أيام شحيحة',
  'Little food and little time between hordes.': 'طعام قليل ووقت قصير بين الجحافل.',
  'Iron Week': 'أسبوع الحديد',
  'Plenty of scrap, but the hordes grow fast.': 'خردة كثيرة، لكن الجحافل تكبر بسرعة.',
  // ---- campaign 20 / objectives / research (D124–D128)
  'Day one after the fall. You lead eight survivors into a quiet valley. Make it a home before the dead find it.': 'اليوم الأول بعد السقوط. تقود ثمانية ناجين إلى وادٍ هادئ. اجعله وطنًا قبل أن يجده الموتى.',
  'The first walkers came at night. Walls would have stopped them. This time, build walls.': 'جاء السائرون الأوائل ليلًا. كانت الأسوار ستوقفهم. هذه المرة، ابنِ الأسوار.',
  'Lost Patrol': 'الدورية المفقودة',
  'Two camps of survivors are cut off in the hills. Reach them before the hordes do.': 'مخيّمان من الناجين محاصران في التلال. اصل إليهم قبل الجحافل.',
  'Our scouts found smoke from two camps in the hills. They will not last another week alone.': 'رأى كشّافونا دخانًا من مخيّمين في التلال. لن يصمدوا أسبوعًا آخر وحدهم.',
  'Scrap keeps the towers firing. The yards are out past the old road — and so are the dead.': 'الخردة تبقي الأبراج تطلق النار. الساحات خلف الطريق القديم — وكذلك الموتى.',
  'The Hive': 'الخلية',
  'A nest of the infected keeps breeding walkers. Burn it out.': 'عشّ للمصابين يواصل إخراج السائرين. أحرقه.',
  'Every night more of them crawl out of the same place. Find the nest and end it.': 'كل ليلة يزحف المزيد منهم من المكان نفسه. اعثر على العش وأنهِه.',
  'Some of them have started to run. Towers before walls fall.': 'بعضهم بدأ يركض. أبراج قبل أن تسقط الأسوار.',
  'Search Party': 'فرقة البحث',
  'Three camps are scattered across the valley. Bring them all home.': 'ثلاثة مخيمات متفرقة في الوادي. أعدهم جميعًا.',
  'Radio chatter from three groups, all moving, all scared. Find them.': 'إشارات راديو من ثلاث مجموعات، كلها تتحرك، كلها خائفة. اعثر عليهم.',
  'The gun towers need power, and power needs scrap. Build the grid before the dark.': 'أبراج الرشاشات تحتاج كهرباء، والكهرباء تحتاج خردة. ابنِ الشبكة قبل الظلام.',
  'Twin Hives': 'الخليتان التوأم',
  'Two nests on either side of the valley. Destroy both.': 'عشّان على جانبي الوادي. دمّرهما.',
  'The scouts were wrong — there are two of them. Split the army or burn them one by one.': 'أخطأ الكشّافون — هناك عشّان. قسّم الجيش أو أحرقهما واحدًا تلو الآخر.',
  'Five hordes, almost no rest between them. Nobody sleeps tonight.': 'خمسة جحافل وتكاد لا تكون هناك راحة. لا أحد ينام الليلة.',
  'Last Convoy': 'القافلة الأخيرة',
  'Four camps, one valley full of the infected. Get everyone out.': 'أربعة مخيمات ووادٍ مليء بالمصابين. أخرج الجميع.',
  'The last convoy from the city broke down in four places. We go get them.': 'تعطّلت القافلة الأخيرة من المدينة في أربعة أماكن. سنذهب لإحضارهم.',
  'The harvest failed. Feed the colony or watch it fall apart from the inside.': 'فشل الحصاد. أطعم المستعمرة أو شاهدها تنهار من الداخل.',
  Brood: 'الحضنة',
  'Three nests feed the hordes. Cut them off at the root.': 'ثلاثة أعشاش تغذّي الجحافل. اقطعها من جذورها.',
  'They are not wandering anymore. They are coming from somewhere. Three somewheres.': 'لم يعودوا يتجولون. إنهم قادمون من مكان ما. من ثلاثة أماكن.',
  Scattered: 'المتفرقون',
  'Five camps hide in a dead forest. Reach them all.': 'خمسة مخيمات مختبئة في غابة ميتة. اصل إليها جميعًا.',
  'The forest swallowed five groups whole. Some of them are still alive in there.': 'ابتلعت الغابة خمس مجموعات. بعضهم ما زال حيًا هناك.',
  'They have surrounded the valley. Six hordes. The last ones are fast.': 'لقد حاصروا الوادي. ستة جحافل. الأخيرة سريعة.',
  'Mother Hive': 'الخلية الأم',
  'Four nests, and they breed fast. Burn them all.': 'أربعة أعشاش تتكاثر بسرعة. أحرقها كلها.',
  'The biggest nest we have ever seen, and three more around it. This is where they come from.': 'أكبر عشّ رأيناه، وثلاثة أخرى حوله. من هنا يأتون.',
  'The old city. Thousands lived here once. Thousands still walk here.': 'المدينة القديمة. عاش هنا الآلاف يومًا. وما زال الآلاف يمشون هنا.',
  Exodus: 'الخروج',
  'Six camps across a ruined city. Everyone comes home or no one does.': 'ستة مخيمات في مدينة مدمّرة. يعود الجميع أو لا يعود أحد.',
  'The city is falling. Six groups are still out there. We leave no one behind.': 'المدينة تسقط. ست مجموعات ما زالت هناك. لن نترك أحدًا خلفنا.',
  Ashes: 'الرماد',
  'Five nests, and the hordes keep coming. Burn the valley clean.': 'خمسة أعشاش والجحافل لا تتوقف. طهّر الوادي بالنار.',
  'One last push into the heart of it. Five nests. If they fall, the valley is ours.': 'دفعة أخيرة إلى القلب. خمسة أعشاش. إن سقطت، صار الوادي لنا.',
  'Everything left out there is coming at once. Hold, and it is over.': 'كل ما تبقى في الخارج قادم دفعة واحدة. اصمد، وينتهي الأمر.',
  'Goal: destroy {n} infected nests': 'الهدف: دمّر {n} أعشاش للمصابين',
  'Goal: reach {n} survivor camps with any unit': 'الهدف: اصل إلى {n} مخيمات للناجين بأي وحدة',
  'Nests destroyed {a}/{b}': 'الأعشاش المدمّرة {a}/{b}',
  'Camps reached {a}/{b}': 'المخيمات المُنقَذة {a}/{b}',
  'Survivors rescued: +{n} people and their supplies.': 'تم إنقاذ ناجين: +{n} أشخاص ومؤنهم.',
  'Every nest is burned out.': 'احترقت كل الأعشاش.',
  'Every survivor is home.': 'عاد كل الناجين.',
  'Infected Nest': 'عشّ المصابين',
  'Survivor Camp': 'مخيم ناجين',
  Start: 'ابدأ',
  'Paused — you can still give orders': 'إيقاف مؤقت — يمكنك إعطاء الأوامر',
  'Game speed is fixed in online matches.': 'سرعة اللعب ثابتة في المباريات الأونلاين.',
  'Online matches cannot be paused.': 'لا يمكن إيقاف المباريات الأونلاين مؤقتًا.',
  'A Screamer called {n} infected to your colony!': 'صارخ استدعى {n} مصابًا إلى مستعمرتك!',
  'A building was overrun — {n} people inside turned.': 'اجتيح مبنى — تحوّل {n} أشخاص كانوا بداخله.',
  Brute: 'العملاق',
  Bloater: 'المنتفخ',
  Screamer: 'الصارخ',
  'Research Lab': 'مختبر الأبحاث',
  Research: 'الأبحاث',
  'Researching {name}': 'جارٍ بحث {name}',
  'Pick a research. One at a time.': 'اختر بحثًا. بحث واحد في كل مرة.',
  'needs {name}': 'يحتاج {name}',
  'Research complete: {name}.': 'اكتمل البحث: {name}.',
  'Sharp Rounds': 'طلقات حادة',
  '+20% rifle damage': '+20٪ ضرر البنادق',
  'Armour-Piercing Rounds': 'طلقات خارقة للدروع',
  '+20% more rifle damage': '+20٪ ضرر إضافي للبنادق',
  'Incendiary Fuel': 'وقود حارق',
  '+30% fire damage': '+30٪ ضرر النار',
  'Close Combat': 'القتال القريب',
  '+25% melee damage': '+25٪ ضرر الالتحام',
  'Body Armour': 'دروع واقية',
  '+20% health for new soldiers': '+20٪ صحة للجنود الجدد',
  'Field Vaccine': 'لقاح ميداني',
  'Bites infect half as fast': 'العضّات تنقل العدوى بنصف السرعة',
  'Drill Sergeants': 'مدرّبون عسكريون',
  'Soldiers train 33% faster': 'تدريب الجنود أسرع بـ33٪',
  'Tall Towers': 'أبراج أعلى',
  'Towers reach 1 tile further': 'مدى الأبراج يزيد مربعًا',
  'Rapid Fire': 'إطلاق سريع',
  'Towers fire 20% faster': 'الأبراج تطلق أسرع بـ20٪',
  'Stone Walls': 'أسوار حجرية',
  'Walls and gates +3 armour': 'الأسوار والبوابات +3 درع',
  'Efficient Generators': 'مولدات فعّالة',
  '+50% power from Generators': '+50٪ كهرباء من المولدات',
  'Crop Rotation': 'تناوب المحاصيل',
  'Farms produce 25% more': 'المزارع تنتج 25٪ أكثر',
  'Power Saws': 'مناشير كهربائية',
  'Sawmills produce 25% more': 'المناشر تنتج 25٪ أكثر',
  'Scrap Presses': 'مكابس الخردة',
  'Scrap Yards produce 25% more': 'ساحات الخردة تنتج 25٪ أكثر',
  // ---- HUD
  Grid: 'الشبكة',
  Terrain: 'التضاريس',
  'Reset view': 'إعادة العرض',
  'Construction — tap a building': 'البناء — اختر مبنى',
  'Construction — choose a building (1–0)': 'البناء — اختر مبنى (1–0)',
  'Army {n}': 'الجيش {n}',
  Box: 'تحديد',
  'Play again': 'العب مجددًا',
  Retry: 'أعد المحاولة',
  'Look around': 'تجوّل',
  'Main menu': 'القائمة الرئيسية',
  'Next: Level {n}': 'التالي: المستوى {n}',
  '☣ Horde {n}/{w} in': '☣ الجحفل {n}/{w} بعد',
  '☣ Horde {n} in': '☣ الجحفل {n} بعد',
  '🛡 Hold': '🛡 اصمد',
  'Tap Main menu again to leave — you can continue later from the menu.': 'المس "القائمة الرئيسية" مرة أخرى للخروج — يمكنك المتابعة لاحقًا من "متابعة".',
  'Level {n} cleared': 'اجتزت المستوى {n}',
  'Level {n} failed': 'فشلت في المستوى {n}',
  'Hordes survived {n}': 'جحافل صمدت أمامها: {n}',
  'You held the line — the last horde is spent.': 'صمدت — انتهى آخر جحفل.',
  'Your colony has fallen.': 'سقطت مستعمرتك.',
  'The last colony standing.': 'آخر مستعمرة صامدة.',
  'Every colony has fallen.': 'سقطت كل المستعمرات.',
  'Colony fallen': 'سقطت المستعمرة',
  'Your colony is under attack!': 'مستعمرتك تتعرض للهجوم!',
  'A horde of infected will emerge in 30 seconds.': 'جحفل من المصابين سيظهر خلال 30 ثانية.',
  'A horde of {n} infected is coming for your colony!': 'جحفل من {n} مصابًا قادم نحو مستعمرتك!',
  'A horde of {n} infected is heading for a rival colony.': 'جحفل من {n} مصابًا يتجه نحو مستعمرة منافسة.',
  // ---- tutorial
  'Drag the map with one finger to look around; pinch to zoom.': 'اسحب الخريطة بإصبع واحد لتستكشف؛ وقرّب بإصبعين.',
  'Drag the map (or WASD) to look around; wheel to zoom.': 'اسحب الخريطة (أو WASD) لتستكشف؛ والعجلة للتقريب.',
  'Food first: tap Farm in the bar at the bottom, tap a green spot near your base, then ✓.': 'الطعام أولًا: المس "مزرعة" في الشريط بالأسفل، ثم مكانًا أخضر قرب قاعدتك، ثم ✓.',
  'Food first: pick Farm in the bar at the bottom (or press 3) and click a green spot near your base.': 'الطعام أولًا: اختر "مزرعة" من الشريط بالأسفل (أو اضغط 3) وانقر مكانًا أخضر قرب قاعدتك.',
  'Wood next: build a Sawmill next to the trees.': 'ثم الخشب: ابنِ منشرة بجوار الأشجار.',
  'More people: build Survivor Housing so new survivors can join.': 'المزيد من الناس: ابنِ مساكن للناجين لينضم ناجون جدد.',
  'Soldiers: build a Military Barracks.': 'الجنود: ابنِ ثكنة عسكرية.',
  'Tap the finished Barracks and train a Ranger.': 'المس الثكنة بعد اكتمالها ودرّب راميًا.',
  'Click the finished Barracks and train a Ranger.': 'انقر الثكنة بعد اكتمالها ودرّب راميًا.',
  'Tap Army to select your soldiers, then tap the ground to send them there.': 'المس "الجيش" لتحديد جنودك، ثم المس الأرض لإرسالهم.',
  'Press Q (or the Army button) to select your soldiers, then click the ground to move them.': 'اضغط Q (أو زر الجيش) لتحديد جنودك، ثم انقر الأرض لتحريكهم.',
  'Defences: build a Watchtower between your base and the middle of the map.': 'الدفاع: ابنِ برج مراقبة بين قاعدتك ومنتصف الخريطة.',
  'A small horde is coming. Keep your soldiers near the base and hold the line!': 'جحفل صغير قادم. أبقِ جنودك قرب القاعدة واصمد!',
};
